export const packingField = [
    {
        name: "pkgId",
        label: 'Packaging Id',
        type: "pkID",
        
    },
    {
        name: "pkgType",
        label: 'Packaging Type',
        type: "select",
        required:true,
        option: ['Carton', 'Envelope', 'Poly Mailer', 'Box', 'Bubble Mailer']
    },
    {
        name: "pkgSize",
        label: 'Packaging Size',
        type: "select",
        required:true,
        readonly:true
    },
    {
        name: "dimensions",
        label: 'Dimensions',
        type: "text",
        readonly:true
    },

    {
        name: "marketplace",
        label: 'Marketplace(s)',
        type: "text",
        
    },

    {
        name: "volumeCapacity",
        label: 'Volume Capacity',
        type: "text",
        readonly:true
    },

    {
        name: "weightCapacity",
        label: 'Weight Capacity',
        type: "text",
        readonly:true
    },

    {
        name: "exclusion",
        label: 'Excluded Commodity Type',
        type: "text",
        readonly:true
    },

     {
        name: "costPerUnit",
        label: 'Cost Per Unit',
        type: "text",
    
    },
  {
        name: "createdBy",
        label: 'Created By',
        type: "text",
        readonly:true
    },

     {
        name: "updatedBy",
        label: 'Updated By',
        type: "text",
        readonly:true
    },

      {
        name: "updatedDate",
        label: 'Updated Date',
        type: "text",
        readonly:true
    },


]